export default function (state, payload) {
  state.visibleAzubis = payload.visibleAzubis
  return {
    ...state,
  }
}
